import { FormControlLabel, Stack, Switch } from '@mui/material'
import { com } from '@eidu/web'
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'
import TrimmedTextField from './TrimmedTextField'
import Location = com.eidu.sharedlib.form.definition.Location

type LocationItemProps = {
  item: Location
  onChange?: (newItem: Location) => void
  onDelete?: () => void
}

const LocationItem: React.FC<LocationItemProps> = ({ item, onChange }) => (
  <Stack
    direction="row"
    spacing={2}
    alignItems="flex-start"
    sx={{
      p: 1,
      bgcolor: 'background.paper',
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Stack direction="row" spacing={2} sx={{ flex: 1 }}>
      <TrimmedTextField
        fullWidth
        value={item.prompt}
        onChange={(e) => onChange?.(withKey(item.copy(e.target.value, item.key, item.required), item))}
        variant="standard"
        placeholder="Enter prompt"
        label="Prompt"
        disabled={!onChange}
      />
      <FormKeyField
        value={item.key}
        onChange={(e) => onChange?.(withKey(item.copy(item.prompt, e.target.value, item.required), item))}
        disabled={!onChange}
      />
      <FormControlLabel
        control={
          <Switch
            checked={item.required}
            onChange={(e) => onChange?.(withKey(item.copy(item.prompt, item.key, e.target.checked), item))}
            disabled={!onChange}
          />
        }
        label="Required"
      />
    </Stack>
  </Stack>
)

export default LocationItem
